module.exports = __webpack_public_path__ + "static/media/insta_icon.1c2d37a5.svg";